import React, { useState } from "react";
import { Collapse, Card, CardBody, CardHeader } from "reactstrap";

const HelpAccordion = ({ category }) => {
    const [openStep, setOpenStep] = useState(null);
    const [openSubStep, setOpenSubStep] = useState({});

    const toggleStep = (stepId) => {
        setOpenStep(openStep === stepId ? null : stepId);
        // Reset sub steps when changing main step
        if (openStep !== stepId) {
            setOpenSubStep({});
        }
    };

    const toggleSubStep = (stepId, subStepId) => {
        setOpenSubStep(prev => ({
            ...prev,
            [stepId]: prev[stepId] === subStepId ? null : subStepId
        }));
    };

    return (
        <div className="mb-4">
            <h5 className="font-size-14 mb-3 d-flex align-items-center">
                <i className={`${category.icon || 'ph-light ph-book-open'} text-primary me-2 font-size-18`}></i>
                {category.title}
            </h5>
            <p className="text-muted font-size-13 mb-3">{category.description}</p>

            <div className="accordion custom-accordion" id={`accordion-${category.id}`}>
                {category.steps.map((step, idx) => {
                    const isOpen = openStep === step.id;
                    return (
                        <Card className="mb-2 shadow-none border" key={step.id}>
                            <CardHeader 
                                className="bg-transparent border-bottom-0 p-3" 
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleStep(step.id)}
                            >
                                <h5 className="font-size-14 m-0 font-weight-normal d-flex justify-content-between align-items-center">
                                    <span className="text-dark fw-medium">
                                        <span className="text-primary fw-bold me-2">{idx + 1}.</span> 
                                        {step.title}
                                    </span>
                                    <i className={`mdi ${isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'} font-size-18 text-muted`}></i>
                                </h5>
                            </CardHeader>

                            <Collapse isOpen={isOpen}>
                                <CardBody className="pt-0 pb-3 text-muted font-size-13">
                                    {step.description && <p className="mb-2 px-2 text-dark">{step.description}</p>}
                                    
                                    {step.content && (
                                        <div dangerouslySetInnerHTML={{ __html: step.content }}></div>
                                    )}

                                    {step.subItems && step.subItems.length > 0 && (
                                        <div className="accordion custom-accordion mt-2 px-2" id={`sub-accordion-${step.id}`}>
                                            {step.subItems.map((subItem, subIdx) => {
                                                const isSubOpen = openSubStep[step.id] === subItem.id;
                                                return (
                                                    <Card className="mb-2 shadow-none border" key={subItem.id}>
                                                        <CardHeader 
                                                            className="bg-light border-bottom-0 p-3" 
                                                            style={{ cursor: "pointer", borderRadius: "0.25rem" }}
                                                            onClick={() => toggleSubStep(step.id, subItem.id)}
                                                        >
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <span className="text-dark d-flex align-items-center fw-medium">
                                                                    {subItem.icon && <i className={`${subItem.icon} me-2 text-primary font-size-16`}></i>}
                                                                    {subIdx + 1}. {subItem.title}
                                                                </span>
                                                                <i className={`mdi ${isSubOpen ? 'mdi-minus' : 'mdi-plus'} font-size-16 text-muted`}></i>
                                                            </div>
                                                        </CardHeader>
                                                        
                                                        <Collapse isOpen={isSubOpen}>
                                                            <CardBody className="pt-2 pb-3 px-3 text-muted font-size-13 border-top">
                                                                <div dangerouslySetInnerHTML={{ __html: subItem.content }}></div>
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                )
                                            })}
                                        </div>
                                    )}
                                </CardBody>
                            </Collapse>
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};

export default HelpAccordion;
